<template>
  <div class="right-bottom-list">
    <titleComponent titleName="孤寡老人巡查"></titleComponent>
    <div class="flex-just">
      <div class="bottom-list">
        <baseDisplay :baseDataList="baseDataList"></baseDisplay>
      </div>
      <div class="bottom-list">
        <rankingDisplay :rankingDataList="rankingDataList" :isName="true"></rankingDisplay>
      </div>
    </div>
    <div class="flex-just">
      <div class="center-point">
        <titleInternal titleName="年龄分布"></titleInternal>
        <div style="width: 732px; height: 380px" v-if="leftCenterThreeList.length">
          <pieTuTwo :optionData="leftCenterThreeList" :totalAge="totalAge"></pieTuTwo>
        </div>
      </div>
      <div class="center-point">
        <titleInternal titleName="完成情况"></titleInternal>
        <div style="width: 732px; height: 380px">
          <wgEchart :options="rightBottomTwoList" id="rightBottomTwo"></wgEchart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wgEchart from "@/components/wgEchart/wgEchart.vue";
import titleInternal from "@/pages/patrolScreen/components/title-internal.vue";
import titleComponent from "@/pages/patrolScreen/components/title.vue";
import pieTuTwo from "@/pages/patrolScreen/components/right/pieTuTwo.vue";
import baseDisplay from "@/pages/patrolScreen/components/base-display.vue";
import rankingDisplay from "@/pages/patrolScreen/components/ranking-display.vue";
import { extendBigScreenGglrTj } from "@/api/daping.js";
import * as echarts from "echarts";
export default {
  name: "index",
  components: {
    wgEchart,
    titleInternal,
    titleComponent,
    pieTuTwo,
    baseDisplay,
    rankingDisplay,
  },
  data() {
    return {
      baseDataList: [
        {
          img: require("@/assets/daping/cgxc.png"),
          name: "常规巡查",
          num: 0,
        },
        {
          img: require("@/assets/daping/zdfx.png"),
          name: "自动发现",
          num: 0,
        },
        {
          img: require("@/assets/daping/bjl.png"),
          name: "巡查率",
          num: 0,
        },
      ],
      rankingDataList: [],
      totalAgeDistribution: "",
      leftCenterThreeList: [],
      colorList: ["#00A3FF", '#F7B467', '#EB5A5A', '#01E8FE', '#f99004'],
      totalAge: 0,
      rightBottomTwoList: {}
    };
  },
  mounted() {
    this.extendBigScreenGglrTj();
  },
  methods: {
    async extendBigScreenGglrTj() {
      let res = await extendBigScreenGglrTj();
      if (res.data.code == 200) {
        let data = res.data.data;
        this.totalAgeDistribution =
          data && data.someCountList.filter((item) => item.label == "年龄分布总数");
        let ageDataList =
          data && data.someCountList.filter((item) => item.label != "年龄分布总数");
        let objectList = ageDataList.reduce((obj, item, index) => {
          obj[item.label] = item.value; // 将数组元素作为对象的属性和值
          return obj;
        }, {});
        this.baseDataList.forEach((item, index) => {
          if (index == 0) {
            item.num = objectList["巡查任务完成数"] + '/' + objectList["巡查任务总数"];
          } else if (index == 1) {
            item.num = objectList["自动发现"]
          } else {
            if (objectList["巡查任务总数"] == 0) {
              item.num = "0%";
            } else {
              item.num = ((objectList["巡查任务完成数"] / objectList["巡查任务总数"]) * 100).toFixed(2) + "%";
            }
          }
        });
        this.rankingDataList = data && data.xcmxTop3;
        this.rankingDataList.forEach((item, index) => {
          item.img = require(`@/assets/daping/img-no${index + 1}.png`)
        })
        this.optionsListDataFive(data && data.nlLineList)
        this.optionsListData(data && data.lineList)
      }
    },
    optionsListDataFive(dataList) {
      this.totalAge = dataList.reduce((sum, current) => sum + Number(current.value), 0);
      this.leftCenterThreeList = JSON.parse(JSON.stringify(dataList));
      this.leftCenterThreeList.forEach((item, index) => {
        item.name = item.label
        item.value = Number(item.value);
        item.itemStyle = {
            //颜色
            color: this.colorList[index]
          }
      })
    },
    optionsListData(dataList) {
      let dateArr = dataList.map(item => item.label);
      let wzArr = dataList.map(item => item.value);
      let gzhArr = dataList.map(item => item.value2);
      this.rightBottomTwoList = {
        grid: {
          left: "20%",
          right: "12%",
          top: "12%",
        },
        legend: {
          show: true,
          itemWidth: 14,
          itemHeight: 8,
          itemGap: 50,
          right: 10,
          textStyle: {
            color: "#E4F2FF",
            fontSize: 16,
          },
        },
        tooltip: {
          // show: true,
          // trigger: "item",
          // formatter: "{b}: {c}",
          backgroundColor: "rgba(3,9,24,0.7)",
          borderColor: "rgba(3,9,24,0.7)",
          textStyle: {
            color: "#fff",
          },
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (param) {
            let res = param[0].name + "<br>";
            for (let j = 0; j < param.length; j++) {
              // 渐变色导致提示框中颜色消失,额外定义
              let marker = `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;background-color:${param[j].color.colorStops[1].color};"></span>`;
              res += marker + param[j].seriesName + ": " + param[j].value + "<br>";
            }
            return res;
          },
        },
        xAxis: {
          type: "value",
          // "max": max,
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(172, 206, 234, 0.2)",
              type: "dashed",
            },
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ADC2D3",
              fontSize: 16,
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            data: dateArr,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              // "margin": 10,
              textStyle: {
                color: "#ADC2D3",
                fontSize: 15,
              },
            },
          },
        ],
        dataZoom: [
          {
            // 设置滚动条的隐藏或显示
            show: true,
            // 设置类型
            type: "slider",
            // 设置背景颜色
            backgroundColor: "rgb(19, 63, 100)",
            // 设置选中范围的填充颜色
            fillerColor: "rgb(16, 171, 198)",
            // 设置边框颜色
            borderColor: "rgb(19, 63, 100)",
            // 是否显示detail，即拖拽时候显示详细数值信息
            showDetail: false,
            // 数据窗口范围的起始数值
            startValue: 0,
            // 数据窗口范围的结束数值（一页显示多少条数据）
            endValue: 9,
            // 控制哪个轴，如果是number表示控制一个轴，
            // 如果是Array表示控制多个轴。此处控制第二根轴
            yAxisIndex: [0, 1],
            // empty：当前数据窗口外的数据，被设置为空。
            // 即不会影响其他轴的数据范围
            filterMode: "empty",
            // 滚动条高度
            width: 8,
            // 滚动条显示位置
            height: "80%",
            // 距离右边
            right: 3,
            // 控制手柄的尺寸
            handleSize: 0,
            // 是否锁定选择区域（或叫做数据窗口）的大小
            zoomLoxk: true,
            // 组件离容器上侧的距离
            // 如果top的值为'top', 'middle', 'bottom'，组件会根据相应的位置自动对齐
            top: "middle",
          },
          {
            // 没有下面这块的话，只能拖动滚动条，
            // 鼠标滚轮在区域内不能控制外部滚动条
            type: "inside",
            // 控制哪个轴，如果是number表示控制一个轴，
            // 如果是Array表示控制多个轴。此处控制第二根轴
            yAxisIndex: [0, 1],
            // 滚轮是否触发缩放
            zoomOnMouseWheel: false,
            // 鼠标移动能否触发平移
            moveOnMouseMove: true,
            // 鼠标滚轮能否触发平移
            moveOnMouseWheel: true,
          },
        ],
        series: [
          {
            //内
            type: "bar",
            barWidth: 6,
            barGap: 0.5,
            name: "任务数",
            label: {
              show: false,
              position: "right",
              textStyle: {
                color: "#fff",
                fontSize: 16,
                padding: [0, 10],
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: 36,
                  },
                },
              },
            },
            legendHoverLink: false,
            silent: true,
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(247,180,103,0)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#F7B467", // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              }, //底色
            },
            data: wzArr,
            zlevel: 13,
          },
          {
            //内2
            type: "bar",
            barWidth: 6,
            name: "完成数",
            legendHoverLink: false,
            silent: true,
            label: {
              show: false,
              position: "right",
              textStyle: {
                color: "#fff",
                padding: [0, 10],
                fontSize: 16,
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: 36,
                  },
                },
              },
            },
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0,163,255,0)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#00A3FF", // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              }, //底色
            },
            data: gzhArr,
            zlevel: 11,
          },
          // {
          //   data: [200, 200, 200, 200, 200],
          //   type: "custom",
          //   xAxisIndex: 0,
          //   barGap: "-100%",
          //   silent: true,
          //   barWidth: 20,
          //   itemStyle: {
          //     normal: {
          //       color: "rgba(255,255,255,0.1)",
          //     },
          //   },
          //   zlevel: 9,
          // },
        ],
      };
    },
  },
};
</script>
<style scoped lang="less">
.right-bottom-list {
  width: 100%;
  .bottom-list {
    width: 732px;
  }
}

.flex-just {
  display: flex;
  justify-content: space-between;
}

.center-point {
  width: 732px;
  height: 450px;
  background: linear-gradient(0, rgba(0, 163, 255, 0) 0%, rgba(0, 163, 255, 0.1) 100%);
  border-radius: 4px;
  margin-top: 18px;
  padding-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreen/components/right/right-bottom.vue